import { GraduationCap, Heart } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  onClick?: () => void;
}

export default function Logo({ size = 'md', showText = true, onClick }: LogoProps) {
  const { theme } = useTheme();

  const sizes = {
    sm: {
      container: 'h-8 w-8',
      icon: 'h-4 w-4',
      text: 'text-sm'
    },
    md: {
      container: 'h-10 w-10',
      icon: 'h-5 w-5',
      text: 'text-xl'
    },
    lg: {
      container: 'h-12 w-12',
      icon: 'h-6 w-6',
      text: 'text-2xl'
    }
  };

  return (
    <div className="flex items-center">
      <div className={`relative ${sizes[size].container} flex items-center justify-center`} onClick={onClick}>
        <div className={`absolute inset-0 bg-${theme.primary} rounded-lg transform rotate-45`} />
        <GraduationCap className={`${sizes[size].icon} text-white relative z-10`} />
        <Heart
          className={`absolute -bottom-1 -right-1 ${sizes[size].icon} text-${theme.text}`}
          fill="currentColor"
        />
      </div>
      {showText && (
        <span className={`ml-3 ${sizes[size].text} font-semibold text-gray-900`}>
          L'oustalet formation
        </span>
      )}
    </div>
  );
}